<template>
  <span class="content-type-badge" :class="badgeClass">
    {{ label }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  labels: {
    type: Object,
    default: () => ({
      'EVENT': '이벤트',
      'EXHIBITION': '전시',
      'NEWS': '뉴스',
      'SPECIAL': '스페셜',
      'ARTIST': '아티스트',
      'ARTWORK': '작품'
    })
  }
})

const label = computed(() => {
  return props.labels[props.type] || props.type
})

const badgeClass = computed(() => {
  const classMap = {
    'EVENT': 'type-event',
    'EXHIBITION': 'type-exhibition',
    'NEWS': 'type-news',
    'SPECIAL': 'type-special',
    'ARTIST': 'type-artist',
    'ARTWORK': 'type-artwork'
  }
  return classMap[props.type] || 'type-default'
})
</script>

<style scoped>
.content-type-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.type-event { background: #e3f2fd; color: #1976d2; }
.type-exhibition { background: #f3e5f5; color: #7b1fa2; }
.type-news { background: #e8f5e8; color: #388e3c; }
.type-special { background: #fff3e0; color: #f57c00; }
.type-artist { background: #fce4ec; color: #c2185b; }
.type-artwork { background: #f1f8e9; color: #689f38; }
.type-default { background: #f5f5f5; color: #666; }
</style>